/*
 * Contrôleur partagé des blocks « henriette-eco-* » (modèle Ecowoman).
 * ---------------------------------------------------------------------------
 * Reproduit le comportement du monolithe « pack-selector » mais réparti sur des
 * blocks autonomes (en-tête, variantes, paliers, CTA, upsell) posés librement
 * dans l'éditeur. Coordination via un store réactif par produit :
 *   state = { options:[valeur par index d'option], qty, variantId, available }
 * Les blocks écrivent dans le store (couleur/taille → options, palier → qty) ;
 * le CTA met à jour les champs cachés du product-form-component natif du thème.
 * Aucun produit forcé : chaque block travaille sur son closest.product.
 * ---------------------------------------------------------------------------
 */
(function () {
  if (window.HeEco) return;

  function makeStore(pid) {
    return {
      pid: pid,
      state: { options: [], qty: 1, total: null, totalStr: null, variantId: null, available: true },
      data: { variants: [], optionCount: 0, currentId: null },
      listeners: [],

      subscribe: function (fn) { this.listeners.push(fn); return fn; },
      notify: function () { var s = this; this.listeners.forEach(function (fn) { try { fn(s); } catch (e) { console.error('[he-eco]', e); } }); },

      merge: function (d) {
        var t = this.data;
        if (d.variants && d.variants.length && !t.variants.length) t.variants = d.variants;
        if (d.optionCount && !t.optionCount) t.optionCount = d.optionCount;
        if (d.currentId && !t.currentId) { t.currentId = d.currentId; if (this.state.variantId == null) this.state.variantId = d.currentId; }
        this.recompute();
        this.notify();
      },

      setOption: function (index, value) { this.state.options[index] = value; this.recompute(); this.notify(); },
      setQty: function (q, total, totalStr) { this.state.qty = q; if (total != null) { this.state.total = total; this.state.totalStr = totalStr; } this.notify(); },

      variantFor: function (opts) {
        return (this.data.variants || []).find(function (v) {
          for (var i = 0; i < opts.length; i++) { if (opts[i] != null && v.options[i] !== opts[i]) return false; }
          return true;
        });
      },
      currentVariant: function () { return this.variantFor(this.state.options) || (this.data.variants || []).find(function (v) { return v.id === this.state.variantId; }, this); },
      recompute: function () {
        var v = this.variantFor(this.state.options);
        if (v) { this.state.variantId = v.id; this.state.available = !!v.available; }
        else { this.state.available = false; }
      }
    };
  }

  var stores = {};
  window.HeEco = {
    stores: stores,
    store: function (pid) { pid = String(pid); return stores[pid] || (stores[pid] = makeStore(pid)); }
  };

  // Ajout panier sans product-form-component (évite le bug de largeur dans les
  // petites cartes du carousel). Pattern identique aux blocks fincut.
  async function addToCart(items) {
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (!res.ok) throw new Error('add failed');
      var cartItemsEl = document.querySelector('cart-items-component[data-section-id]');
      if (cartItemsEl) {
        var sectionId = cartItemsEl.dataset.sectionId;
        var url = new URL(window.location.href);
        url.searchParams.set('section_id', sectionId);
        var sr = await fetch(url.toString());
        var html = await sr.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var ns = doc.getElementById('shopify-section-' + sectionId);
        var es = document.getElementById('shopify-section-' + sectionId);
        if (ns && es) {
          var nc = ns.querySelector('cart-items-component'); var ec = es.querySelector('cart-items-component');
          if (nc && ec) ec.innerHTML = nc.innerHTML;
          var dlg = es.querySelector('.cart-drawer__dialog'); if (dlg) dlg.classList.remove('cart-drawer--empty');
        }
      }
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') drawer.open();
      else window.location.href = '/cart';
    } catch (e) { console.error('[he-eco]', e); window.location.href = '/cart'; }
  }

  function ingestData() {
    document.querySelectorAll('.he-eco-data').forEach(function (el) {
      if (el.__heRead) return; el.__heRead = true;
      var data; try { data = JSON.parse(el.textContent); } catch (e) { return; }
      HeEco.store(el.dataset.product).merge(data);
    });
  }

  // Fait défiler la galerie média native jusqu'à la photo de la variante choisie.
  function syncGallery(mediaId) {
    if (!mediaId) return;
    var scroller = document.querySelector('media-gallery slideshow-slides');
    if (!scroller) return;
    var node = scroller.querySelector('[data-media-id="' + mediaId + '"]');
    if (!node) return;
    var slide = node.closest('slideshow-slide') || node;
    if (scroller.scrollBy) {
      var delta = slide.getBoundingClientRect().left - scroller.getBoundingClientRect().left;
      if (Math.abs(delta) > 2) scroller.scrollBy({ left: delta, behavior: 'smooth' });
    } else if (slide.scrollIntoView) {
      slide.scrollIntoView({ inline: 'start', block: 'nearest', behavior: 'smooth' });
    }
  }

  var INITS = {};

  // ---- en-tête : titre (statique) + prix réactif ----
  INITS.header = function (root, store) {
    function render() {
      var v = store.currentVariant() || {};
      var now = root.querySelector('[data-he-eco-now]');
      var was = root.querySelector('[data-he-eco-was]');
      var badge = root.querySelector('[data-he-eco-badge]');
      if (v.price == null) return;
      if (now) now.textContent = money(v.price);
      if (v.compare_at_price > v.price) {
        if (was) { was.textContent = money(v.compare_at_price); was.hidden = false; }
        if (badge) { badge.hidden = false; badge.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
      } else {
        if (was) was.hidden = true;
        if (badge) badge.hidden = true;
      }
    }
    store.subscribe(render); render();
  };

  // ---- variantes : couleur + taille (les swatches/tailles sont rendus en Liquid) ----
  INITS.variants = function (root, store) {
    root.querySelectorAll('.ps-variant').forEach(function (fs) {
      var index = parseInt(fs.dataset.abOptionIndex, 10);
      var checked = fs.querySelector('input:checked');
      if (checked) store.state.options[index] = checked.value;
      fs.querySelectorAll('.ps-value').forEach(function (val) {
        val.addEventListener('click', function () {
          fs.querySelectorAll('.ps-value').forEach(function (x) { x.classList.remove('is-selected'); });
          val.classList.add('is-selected');
          var i = val.querySelector('input'); if (i) i.checked = true;
          store.setOption(index, i ? i.value : null);
          var cur = fs.querySelector('[data-ab-current]'); if (cur && i) cur.textContent = i.value;
          // changement de couleur → affiche la photo de la variante dans la galerie
          if (fs.classList.contains('ps-variant--color')) {
            var v = store.currentVariant();
            if (v && v.featured_media) syncGallery(v.featured_media.id);
          }
        });
      });
    });
    store.recompute();

    // guide des tailles (drawer)
    var open = root.querySelector('[data-ps-sizeguide-open]');
    var dlg = root.querySelector('[data-ps-sizeguide]');
    if (open && dlg) open.addEventListener('click', function () { if (dlg.showModal) dlg.showModal(); });
    var close = root.querySelector('[data-ps-sizeguide-close]');
    if (close && dlg) close.addEventListener('click', function () { dlg.close(); });

    function render() {
      root.querySelectorAll('.ps-variant').forEach(function (fs) {
        var index = parseInt(fs.dataset.abOptionIndex, 10);
        var sel = store.state.options[index];
        fs.querySelectorAll('.ps-value').forEach(function (val) {
          var i = val.querySelector('input');
          val.classList.toggle('is-selected', !!(i && i.value === sel));
        });
      });
    }
    store.subscribe(render);
  };

  // ---- paliers (prix fixes) : sélectionne la quantité ----
  INITS.packs = function (root, store) {
    root.querySelectorAll('.ps-card').forEach(function (card) {
      card.addEventListener('click', function () {
        root.querySelectorAll('.ps-card').forEach(function (c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        var rd = card.querySelector('input'); if (rd) rd.checked = true;
        store.setQty(parseInt(card.dataset.qty, 10) || 1, parseInt(card.dataset.total, 10), card.dataset.totalStr);
      });
    });
    var sel = root.querySelector('.ps-card.is-selected');
    if (sel) { store.state.qty = parseInt(sel.dataset.qty, 10) || 1; store.state.total = parseInt(sel.dataset.total, 10); store.state.totalStr = sel.dataset.totalStr; }
  };

  // ---- CTA : product-form-component natif, champs cachés pilotés par le store ----
  INITS.cta = function (root, store) {
    var input = root.querySelector('[data-ab-variant-id]');
    var qtyInput = root.querySelector('[data-ab-quantity]');
    var btn = root.querySelector('[data-ab-cta]');
    var label = btn ? btn.querySelector('.ps-cta-label') : null;

    var priceEl = root.querySelector('[data-eco-cta-price]');
    var stickyBtn = null; // clone du bouton dans la barre fixe mobile (voir setupSticky)
    function syncSticky() {
      if (!stickyBtn || !btn) return;
      stickyBtn.disabled = btn.disabled;
      stickyBtn.innerHTML = btn.innerHTML; // recopie label + prix à jour
    }
    function render() {
      if (qtyInput) qtyInput.value = String(store.state.qty || 1);
      if (input) { if (store.state.variantId) input.value = store.state.variantId; input.disabled = !store.state.available; }
      if (btn) { btn.disabled = !store.state.available; if (label) label.textContent = store.state.available ? btn.dataset.addLabel : btn.dataset.soldLabel; }
      if (priceEl) {
        var v = store.currentVariant();
        var str = store.state.totalStr || (store.state.total != null ? money(store.state.total) : (v ? money((v.price || 0) * (store.state.qty || 1)) : ''));
        priceEl.textContent = str || '';
      }
      syncSticky();
    }
    store.subscribe(render); render();

    // Interception : ouvre le popup upsell (pochette imperméable) comme le widget bundle.
    btn && btn.addEventListener('click', function (e) {
      if (!window.heBundleUpsell || typeof window.heBundleUpsell.open !== 'function') return;
      if (!input || input.disabled || !input.value) return;
      e.preventDefault(); e.stopImmediatePropagation();
      window.heBundleUpsell.open([{ id: parseInt(input.value, 10), quantity: parseInt(qtyInput && qtyInput.value || store.state.qty || '1', 10) || 1 }]);
    }, true);

    // Barre fixe en bas sur mobile (barre séparée qui glisse quand le vrai bouton
    // sort de l'écran ; le bouton inline ne bouge jamais → transitions fluides).
    if (root.dataset.sticky === 'true') {
      setupSticky(root, btn, function (clone) { stickyBtn = clone; syncSticky(); });
    }
  };

  // Barre fixe mobile = élément séparé appendu au <body> (pour échapper aux ancêtres
  // transform/contain qui piègent position:fixed). Le vrai bouton inline ne bouge
  // jamais : la barre glisse simplement en/hors écran selon que le bouton est visible.
  function setupSticky(root, btn, onClone) {
    var mq = window.matchMedia('(max-width: 749px)');
    var active = false;
    var io = null;
    var bar = null;

    function buildBar() {
      if (bar) return;
      bar = document.createElement('div');
      bar.className = 'he-eco-cta-bar';
      bar.setAttribute('data-product', root.getAttribute('data-product') || '');
      var inner = document.createElement('div');
      inner.className = 'he-eco-cta-bar__inner';
      var clone = document.createElement('button');
      clone.type = 'button';
      clone.className = 'ps-cta he-eco-cta-bar__btn';
      clone.style.cssText = 'background:#324e57;color:#fff;border:0;border-radius:999px;';
      clone.innerHTML = btn ? btn.innerHTML : '';
      // Le clic relaie le vrai bouton (réutilise l'interception upsell + submit form).
      clone.addEventListener('click', function () { if (btn && !btn.disabled) btn.click(); });
      inner.appendChild(clone);
      bar.appendChild(inner);
      if (typeof onClone === 'function') onClone(clone);
    }

    function show() { if (bar) bar.classList.add('is-visible'); }
    function hide() { if (bar) bar.classList.remove('is-visible'); }

    function engage() {
      if (active) return;
      active = true;
      buildBar();
      // nettoie une éventuelle barre orpheline (re-render éditeur)
      document.querySelectorAll('body > .he-eco-cta-bar').forEach(function (el) { if (el !== bar) el.remove(); });
      document.body.appendChild(bar);
      // barre visible tant que le vrai bouton n'est PAS à l'écran
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) hide(); else show(); });
      }, { threshold: 0 });
      io.observe(root);
    }

    function disengage() {
      if (!active) return;
      active = false;
      if (io) { io.disconnect(); io = null; }
      if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
    }

    function apply() { if (mq.matches) engage(); else disengage(); }
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
  }

  // ---- upsell « complete your look » : carousel de cartes (1 par produit haut) ----
  INITS.upsell = function (root) {
    root.querySelectorAll('.ps-upsell__card').forEach(function (card) {
      var list; try { list = JSON.parse(card.querySelector('[data-ab-up-variants]').textContent); } catch (e) { list = []; }
      var btn = card.querySelector('[data-eco-up-add]');
      function currentVariant() {
        var si = card.querySelector('input[name^="upsize-"]:checked');
        return list.find(function (x) { return !si || x.options.indexOf(si.value) !== -1; });
      }
      card.querySelectorAll('.ps-upsell__size').forEach(function (us) {
        us.addEventListener('click', function () {
          card.querySelectorAll('.ps-upsell__size').forEach(function (x) { x.classList.remove('is-selected'); });
          us.classList.add('is-selected');
          var i = us.querySelector('input'); if (i) i.checked = true;
        });
      });
      if (btn) btn.addEventListener('click', function () {
        var v = currentVariant();
        if (!v || v.available === false) return;
        addToCart([{ id: v.id, quantity: 1 }]);
      });
    });
    // Guide des tailles unique (overlay div show/hide — pas de <dialog>).
    var open = root.querySelector('[data-ps-upsell-sg-open]');
    var sg = root.querySelector('[data-ps-upsell-sg]');
    function sgClose() { if (!sg) return; sg.hidden = true; document.body.style.overflow = ''; }
    function sgOpen() { if (!sg) return; sg.hidden = false; document.body.style.overflow = 'hidden'; }
    if (open && sg) open.addEventListener('click', sgOpen);
    var close = root.querySelector('[data-ps-upsell-sg-close]');
    if (close) close.addEventListener('click', sgClose);
    if (sg) {
      sg.addEventListener('click', function (e) { if (e.target === sg) sgClose(); }); // clic sur le fond
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sg.hidden) sgClose(); });
    }
  };

  function money(cents) {
    try { return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'EUR' }); }
    catch (e) { return (cents / 100).toFixed(2); }
  }

  function boot(scope) {
    ingestData();
    (scope || document).querySelectorAll('[data-he-eco]').forEach(function (root) {
      if (root.__heEcoInit) return;
      var init = INITS[root.dataset.block];
      if (!init) return;
      root.__heEcoInit = true;
      init(root, HeEco.store(root.dataset.product));
    });
    Object.keys(stores).forEach(function (pid) { stores[pid].notify(); });
  }

  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) { boot(e.target.closest('.shopify-section') || document); });

  // Le thème navigue côté client (View Transitions : pageswap/pagereveal) + bfcache.
  // Dans ces cas le cycle DOMContentLoaded ne se rejoue pas → boot() n'avait jamais
  // (re)câblé les blocks de la nouvelle page → clics taille/pack sans effet, ajout en
  // XS/qté 1. On re-boote sur ces événements (idempotent via __heEcoInit) pour
  // recâbler les blocks fraîchement révélés.
  window.addEventListener('pageshow', function () { boot(); });
  window.addEventListener('pagereveal', function () { boot(); });

  // Filet de sécurité indépendant de l'init : au clic « ajouter au panier », on
  // reconstruit la sélection à partir de l'état NATIF des radios (cochés par le clic
  // sur le label, même sans JS) et on écrit variante + quantité dans les champs cachés
  // AVANT que l'interception upsell (capture sur le bouton) ou le submit natif ne les
  // lisent. Garantit le bon ajout quelle que soit la séquence d'initialisation.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-ab-cta]') : null;
    if (!btn) return;
    var ctaRoot = btn.closest('[data-he-eco]');
    if (!ctaRoot) return;
    var pid = ctaRoot.dataset.product;
    var store = HeEco.store(pid);
    ingestData(); // au cas où les variantes n'auraient pas encore été lues

    var vb = document.querySelector('[data-he-eco][data-block="variants"][data-product="' + pid + '"]');
    if (vb) {
      vb.querySelectorAll('.ps-variant').forEach(function (fs) {
        var idx = parseInt(fs.dataset.abOptionIndex, 10);
        var checked = fs.querySelector('input:checked');
        if (checked) store.state.options[idx] = checked.value;
      });
    }
    var pb = document.querySelector('[data-he-eco][data-block="packs"][data-product="' + pid + '"]');
    if (pb) {
      var cp = pb.querySelector('.ps-card input:checked');
      var card = cp && cp.closest('.ps-card');
      if (card && card.dataset.qty) store.state.qty = parseInt(card.dataset.qty, 10) || 1;
    }
    store.recompute();
    var input = ctaRoot.querySelector('[data-ab-variant-id]');
    var qtyInput = ctaRoot.querySelector('[data-ab-quantity]');
    if (input && store.state.variantId) input.value = store.state.variantId;
    if (qtyInput) qtyInput.value = String(store.state.qty || 1);
  }, true);

  window.HeEco.boot = boot;
})();
